import { BLANK_ARR } from "../../constants"

export const sum = (arr = BLANK_ARR) => {
    let ret = 0
    arr.forEach(e => ret += e.value)
    return ret
}
export const toCurrency = (num = 0) => `$${num.toFixed(2)}`
